import { VAIBHAV_YOUTUBE_CHANNEL_URL } from "@/lib/cms";

export default function ResourceHero() {
  return (
    <section
      id="all-resources-hero"
      className="w-full bg-black font-fira text-white py-10"
    >
      {/* Frame: full width mobile, 98% desktop; 1px gradient border */}
      <div className="mx-auto w-[90%] md:w-[98%]">
        <div className="rounded-b-2xl rounded-t-none p-px md:rounded-b-3xl">
          <div className="relative min-h-[min(80dvh,44rem)] overflow-hidden rounded-3xl  md:min-h-[min(65dvh,40rem)] md:rounded-b-3xl border border-[#FFFFFF29]">
            {/* Background image */}
            <picture className="pointer-events-none absolute inset-0">
              <source
                media="(min-width: 768px)"
                srcSet="/resources/allresourced.webp"
              />
              <img
                src="/resources/allresourcem.webp"
                alt=""
                className="h-full w-full object-cover object-center"
                loading="eager"
                decoding="async"
                fetchPriority="high"
              />
            </picture>

            {/* Dark overlay on the left so text is readable */}
            <div className="pointer-events-none absolute inset-0" />

            {/* Content */}
            <div className="relative z-10 flex min-h-[min(80dvh,44rem)] flex-col justify-end md:justify-center px-8 py-12 md:min-h-[min(65dvh,40rem)] md:px-16 md:py-16 lg:px-24">
              <div className="flex md:max-w-xl flex-col items-start">
                <h1 className="font-fira-condensed text-[36px] font-medium md:font-semibold leading-tight tracking-tight text-white md:text-[56px]">
                  Watch, learn, Stay Ahead
                </h1>

                <p className="font-fira mt-3 text-[14px] font-normal leading-relaxed text-[#FFFFFF80] md:mt-4 md:text-[18px]">
                  A growing library of long-form videos, tutorials, and updates
                </p>

                <div className="mt-6 flex flex-col md:flex-row w-full items-center gap-3 md:mt-8">
                  <a
                    href={VAIBHAV_YOUTUBE_CHANNEL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex bg-white text-black w-full items-center justify-center rounded-lg border border-[#FFFFFF4D] bg-transparent px-6 py-3 text-center text-sm font-medium transition hover:bg-white/5 md:w-auto md:px-8"
                  >
                    Subscribe on{" "}
                    <span>
                      <img
                        src="/homepage/youtube.svg"
                        alt="YouTube"
                        className="h-4 w-auto ml-2 invert"
                      />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
